<div id="confirm">
    <div class="imagery" style="background-image:url(assets/images/road-1.jpg);"></div>
    </div><!-- dialogue -->
    <div *ngIf= "alert" class="announce visible announce-margin">
        <div class="area">
            <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>&nbsp;<span>{{alert.message}} </span>            
        <div>
    </div>              
</div><!-- login -->
